<template>
  <section style="background:#DDD">
    <Banner value="Logotipo"/>
    <AppLogo/>
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import AppLogo from "../../components/AppLogo";

export default {
  data: () => ({}),
  components: {
    Banner,
    AppLogo
  }
};
</script>

<style lang="scss" scoped>
</style>

